<template>
  <div class="nav-wrapper">
    <!-- <select v-model="$i18n.locale" @change="onChange">
			<option
				selected
				v-for="(lang, i) in langs"
				:key="`Lang${i}`"
				:value="lang"
				:data-qa="`${lang}Button`">{{ lang }}
			</option>
		</select> -->
    <ImageSelect
      v-model="imageValue"
      :options="imageOptions"
      label="title"
      track-by="title"
      :show-labels="false"
    />
  </div>
</template>

<script>
import ImageSelect from '../../components/common/ImageSelect.vue'

export default {
  components: {
    ImageSelect
  },
  name: 'LanguageSwitcher',
  data() {
    return {
      // langs: [
      // 	'en',
      // 	'sl',
      // ],
      imageValue: {
        title: 'sl',
        img:
          'https://upload.wikimedia.org/wikipedia/commons/f/f0/Flag_of_Slovenia.svg'
      },
      imageOptions: [
        {
          title: 'en',
          img:
            'https://upload.wikimedia.org/wikipedia/commons/a/a5/Flag_of_the_United_Kingdom_%281-2%29.svg'
        },
        {
          title: 'sl',
          img:
            'https://upload.wikimedia.org/wikipedia/commons/f/f0/Flag_of_Slovenia.svg'
        },
        {
          title: 'hr',
          img:
            'https://upload.wikimedia.org/wikipedia/commons/1/1b/Flag_of_Croatia.svg'
        }
      ]
    }
  },
  methods: {
    onChange(event) {
      localStorage.setItem('i18n-locale', event.target.value)
      this.$router.replace({ params: { lang: event.target.value } })
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-wrapper {
  display: inline;
  text-align: center;
  font-size: 1.3rem;
}

select {
  // A reset of styles, including removing the default dropdown arrow
  appearance: none;
  color: var(--bright);
  min-width: 3ch;
  max-width: 5ch;
  border: none;
  border-radius: 0.25em;
  padding: 0.25em 0.5em;
  font-size: 1.25rem;
  cursor: pointer;
  line-height: 1.1;
  background-color: none;
  background-image: none;
  text-transform: uppercase;
  outline: none;
}
option {
  color: var(--primary);
  background: var(--bg);
  outline: none;
}

/* CAUTION: Internet Explorer hackery ahead */

select::-ms-expand {
  display: none; /* Remove default arrow in Internet Explorer 10 and 11 */
}

/* Target Internet Explorer 9 to undo the custom arrow */
@media screen and (min-width: 0\0) {
  select {
    background: none\9;
    padding: 5px\9;
  }
}
</style>
